
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";

export function useKycStatus() {


    const register = useSelector(({ Register }) => Register?.user);
    const login = useSelector(({ Login }) => Login?.user);

    let isVerified = false;
    if ((register && register?.kycDetails?.verified) || ((login && login?.kycDetails?.verified))) {
        isVerified = true;
    }

    return isVerified;
}


export function useKycCompleted() {


    const register = useSelector(({ Register }) => Register?.user);
    const login = useSelector(({ Login }) => Login?.user);

    let kycCompleted = register && register?.kycDetails?.status || login && login?.kycDetails?.status
    return kycCompleted;
}
